import {connect} from 'react-redux';
import {createSelector} from 'reselect';
import {Notebook as Component} from './Notebook';
import {
  setNoteBookSection,
  toggleNotebookCollapse,
} from '@learningblocks/exp-redux/lib/Actions';
import {NOTEBOOK_SECTIONS} from '@learningblocks/exp-constants/lib/Utilities';

function mapStateToProps(state) {
  return {
    ...getSectionsProps(state),
    sectionComponents: getSectionComponents(state),
    visible: !state.notebook.notebookCollapsed,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    goToSection: (section) => {
      dispatch(setNoteBookSection(section));
    },
    toggleCollapse: (toggleValue) => {
      dispatch(toggleNotebookCollapse(toggleValue));
    },
  };
}

export const Notebook = connect(mapStateToProps, mapDispatchToProps)(Component);

const getSections = ({notebook}) => {
  return notebook.sections;
};
const getSectionsProps = createSelector([getSections], (sections) => {
  const currentSectionIndex = sections.findIndex((section) => section.current);
  let currentSection = {};
  let nextSection = {};
  let showOverlay = true;
  if (currentSectionIndex >= 0) {
    currentSection = sections[currentSectionIndex];
    if (currentSection.value === NOTEBOOK_SECTIONS.DESIGN) {
      showOverlay = false;
    }
    if (currentSectionIndex + 1 < sections.length) {
      nextSection = sections[currentSectionIndex + 1];
      if (currentSection.value === NOTEBOOK_SECTIONS.DESIGN) {
        nextSection = sections[0];
      }
    }
  }
  return {sections, currentSection, nextSection, showOverlay};
});
const getCurrentSection = ({notebook}) => notebook.currentSection;

const getSectionComponents = createSelector(
  [getCurrentSection],
  (currentSection) => (currentSection ? currentSection.components : [])
);

export {NotebookComponent} from './NotebookComponents';
